import type { TextFieldProps } from '@mui/material/TextField';

import CircularProgress from '@mui/material/CircularProgress';
import { FiSearch } from '@react-icons/all-files/fi/FiSearch';
import { FiX } from '@react-icons/all-files/fi/FiX';
import { useCallback, useMemo } from 'react';
import { debounce } from '@mui/material';
import { InputText } from '../../input';

type ISearchInputProps = TextFieldProps & {
  placeholder: string;
  isLoading: boolean;
  handleChange: any;
  handleClose: any;
  inputProps?: any;
  autoFocus?: boolean;
  dialogMode?: boolean;
  showCloseInputIcon?: boolean;
};

export function SearchInput({
  handleChange,
  placeholder,
  handleClose,
  isLoading,
  inputProps,
  autoFocus = true,
  dialogMode = false,
  showCloseInputIcon = false,
  ...props
}: ISearchInputProps) {
  const endAdornment = useMemo(() => {
    if (isLoading) return <CircularProgress size={29} />;

    if (showCloseInputIcon) return <FiX size={20} />;

    return null;
  }, [isLoading, showCloseInputIcon]);

  const delayedFetchData = useCallback(debounce(handleChange, 1000), []);

  const onHandleChange = async (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { value } = e.target;

    delayedFetchData(value);
  };

  return (
    <InputText
      testId="search-input"
      id="search-input"
      fullWidth
      autoFocus={autoFocus}
      onChange={onHandleChange}
      placeholder={placeholder}
      size="small"
      identifierIcon={<FiSearch size={22} />}
      sx={{
        height: dialogMode ? 50 : undefined,
      }}
      actions={[
        {
          icon: endAdornment as any,
          handler: handleClose,
        },
      ]}
      {...props}
    />
  );
}
